export default "__VITE_ASSET__BcmGp2dI__"